import RequestBuilder from 'Resources/RequestBuilder';
import ComparisonTypes from 'Resources/ComparisonTypes';

// Virtual folder with no DB row; never pass this id to FoldersResource.
export const MEETINGS_FOLDER_ID = -1;

const APPOINTMENT_ENTITY = 'Appointment';

export const isMeetingsFolder = (folderId?: number | null) => folderId === MEETINGS_FOLDER_ID;

const addBaseFilters = (rb: RequestBuilder, clientIds: number[]) => {
	rb.addFilter({ field: 'client.id' }, ComparisonTypes.Equals, clientIds);
	rb.addFilter({ field: 'mimetype' }, ComparisonTypes.NotEquals, 'text/calendar');
	rb.addFilter({ field: 'isInline' }, ComparisonTypes.NotEquals, true);
};

const addRootFolderFilter = (rb: RequestBuilder) => {
	const or = rb.orBuilder();
	or.next();
	or.addFilter({ field: 'driveFolderId' }, ComparisonTypes.Equals, 0);
	or.next();
	or.addFilter({ field: 'driveFolderId' }, ComparisonTypes.Equals, null);
	or.done();
};

const addMeetingsFilter = (rb: RequestBuilder) => {
	rb.addFilter({ field: 'entity' }, ComparisonTypes.Equals, APPOINTMENT_ENTITY);
	addRootFolderFilter(rb);
};

type FileRequestOptions = {
	clientIds: number[];
	searchString: string | null;
	currentFolderId: number | null;
	hasMeetingsFolder: boolean;
};

export const buildFileRequest = ({
	clientIds,
	searchString,
	currentFolderId,
	hasMeetingsFolder
}: FileRequestOptions) => {
	const rb = new RequestBuilder();
	addBaseFilters(rb, clientIds);

	if (searchString) {
		rb.addFilter({ field: 'filename' }, ComparisonTypes.Wildcard, searchString);
	} else if (isMeetingsFolder(currentFolderId)) {
		addMeetingsFilter(rb);
	} else if (currentFolderId) {
		rb.addFilter({ field: 'driveFolderId' }, ComparisonTypes.Equals, currentFolderId);
	} else {
		addRootFolderFilter(rb);
		if (hasMeetingsFolder) {
			rb.addFilter({ field: 'entity' }, ComparisonTypes.NotEquals, APPOINTMENT_ENTITY);
		}
	}

	return rb;
};

export const buildMeetingsCountRequest = (clientIds: number[]) => {
	const rb = new RequestBuilder();
	addBaseFilters(rb, clientIds);
	addMeetingsFilter(rb);
	rb.limit = 1;
	return rb;
};
